import { createAnalyticsInterface } from "@gwn/guac-lib/dist/interfaces/analytics";

export const getStandaloneInterfaces = () => {
  const measurementId = process.env.VUE_APP_GA_MEASUREMENT_ID;

  return {
    analyticsInterface: createAnalyticsInterface({
      applicationName: "@getwell/guac-layout-standalone",
      serviceName: measurementId ? "googleAnalytics" : "disabled",
      trackingId: measurementId,
    }),
  };
};

export const reportException = async (error: Error) => {
  const { createReportingInterface } = await import("@gwn/guac-lib/dist/interfaces/reporting");
  const dsn = process.env.VUE_APP_SENTRY_DSN;
  const env = process.env.VUE_APP_ENVIRONMENT;
  createReportingInterface({
    serviceName: dsn && env !== "local" ? "sentry" : "disabled",
    dsn: dsn,
    version: process.env.VERSION,
    environment: env,
  }).captureException(error);
};
